import * as THREE from 'three'

export const intiTHREEMusketeers = async ({ renderer, scene, camera }) => {
    // Check if THREE Musketeers has not been loaded before
    if (!!window.$$$ === false) {
        return await (async () => {
            const { default: musketeers } = await import('three-musketeers')
            window.$$$ = musketeers({ renderer, scene, camera })

            const toScreenPosition = (obj, camera, renderer) => {
                let vector = new THREE.Vector3()

                const widthHalf = 0.5 * renderer.context.canvas.width
                const heightHalf = 0.5 * renderer.context.canvas.height

                obj.updateMatrixWorld()
                vector.setFromMatrixPosition(obj.matrixWorld)
                vector.project(camera)

                vector.x = vector.x * widthHalf + widthHalf
                vector.y = -(vector.y * heightHalf) + heightHalf

                return {
                    x: vector.x,
                    y: vector.y,
                }
            }

            const onMeshClick = function(e) {
                const C = $$$.constants
                const renderer = $$$.getResource(C.RENDERER)
                const camera = $$$.getResource(C.CAMERA)

                const screenPosition = toScreenPosition(e, camera, renderer)

                const clientX = screenPosition.x
                const clientY = screenPosition.y

                const touchObj = new Touch({
                    identifier: Date.now(),
                    target: document.getElementsByTagName('body')[0],
                    clientX,
                    clientY,
                    radiusX: 2.5,
                    radiusY: 2.5,
                    rotationAngle: 10,
                    force: 0.5,
                })

                const touchEvent = new TouchEvent('touchstart', {
                    cancelable: true,
                    bubbles: true,
                    touches: [touchObj],
                    targetTouches: [],
                    changedTouches: [touchObj],
                    shiftKey: true,
                })

                e._3xDomEvent.touchstartHandlers[0].callback(touchEvent)
            }

            window.$$$.init = function() {
                var hitMeshes = window.$$$.getHitMeshes()

                for (var hitmesh of hitMeshes) {
                    hitmesh.on('click', onMeshClick)
                }
            }

            window.$$$.destroy = function(hitMeshes) {
                for (var hitmesh of hitMeshes) {
                    hitmesh.off('click', onMeshClick)
                }

                $$$.store.reset()
            }

            window.$$$.getHitMeshes = function() {
                return window.$$$.findAll(node => node.name === 'HitMesh')
            }

            window.$$$.init()

            return window.$$$.getHitMeshes()
        })()
    } else {
        window.$$$.setResource({ camera, renderer, scene })
        window.$$$.init()

        return window.$$$.getHitMeshes()
    }
}

export const disposeTHREEMusketeerHitMeshes = hitMeshes =>
    window.$$$ && window.$$$.destroy && window.$$$.destroy(hitMeshes)
